
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-17.5%","y":"-12.5%","width":"135%","height":"135%","filterUnits":"objectBoundingBox","id":"a"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0","in":"shadowBlurOuter1"}})]),_c('rect',{attrs:{"id":"b","x":"0","y":"0","width":"40","height":"40","rx":"2"}})]),_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('g',{attrs:{"transform":"translate(4 2)"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#a)","xlink:href":"#b"}}),_c('use',{attrs:{"fill":"#4788C6","xlink:href":"#b"}})]),_c('path',{attrs:{"d":"M30.977 14H16.713a.67.67 0 00-.597.364.68.68 0 00.052.707l5.226 7.362.006.007c.19.257.292.567.293.886v6.002a.668.668 0 00.93.62l2.937-1.12c.263-.08.437-.33.437-.628v-4.874c0-.319.104-.63.293-.886l.006-.007 5.226-7.362a.679.679 0 00.053-.707.67.67 0 00-.598-.364z","fill":"#FFF"}})])])
          )
        }
      }
    